/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport, LocaleProvider } from '@typescript-kit/core';

import * as texts from './text/shell.de.text.json';
import * as resources from './resource/shell.resource.json';

export class ShellInitializer {

  static initialize() {
    ShellInitializer.registerLocales();
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'shell', {
      texts: getJsonExport(texts),
      resources: getJsonExport(resources)
    });
  }
}
